export class  ChangeControlSearch{
    eQMSScopes?:string[];
    targetCompletionDates?:Date[];
    responsibleSubBUs?:string[];
    phases?:string[];
    categories?:string[];
    searchText?: string;
    users?:string[];
}